export default __webpack_public_path__ + "static/media/poigne-de-main.d07c15a6.png";